import { render, staticRenderFns } from "./SubscriptionManagementView.vue?vue&type=template&id=0c89e4ba"
import script from "./SubscriptionManagementView.vue?vue&type=script&lang=js"
export * from "./SubscriptionManagementView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports